import AlertMessage from 'components/AlertMessage';
import Loading from 'components/Loading';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { Button, Form } from 'shards-react';
import useFetch from 'utils/hooks/useFetch';
import { updateUserData } from 'utils/redux/actions';
import StatefulField from './StatefulField';
// import ToggleMailNotifications from './ToggleMailNotifications';

const ProlifeInfo = ({ dispatch, fullName, settings }) => {
  const { registeredJobMail } = settings;
  const [userName, setUserName] = useState(() => fullName);
  const [mailNottifications, setMailNottifications] = useState(() => registeredJobMail);
  const { status, error, data, fetchData } = useFetch({ method: 'POST', url: '/settings/update-self-info', immediate: false });

  const isNameEmpty = useMemo(() => userName.trim() === '', [userName]);
  const hint = useMemo(() => isNameEmpty && 'Das Feld wird benötigt, um die Info zu aktualisieren!', [isNameEmpty]);
  const isLoading = useMemo(() => status === 'fetching', [status]);
  const isFetched = useMemo(() => status === 'fetched' && data === 'OK', [status, data]);
  const isNameChanged = useMemo(() => userName !== fullName, [userName, fullName]);
  const isNotificationsChanged = useMemo(() => mailNottifications !== registeredJobMail, [mailNottifications, registeredJobMail]);
  const isDisabled = useMemo(() => isLoading || isNameEmpty || (!isNameChanged && !isNotificationsChanged), [isLoading, isNameEmpty, isNameChanged, isNotificationsChanged]);

  const submitHandeler = useCallback(
    (e) => {
      e.preventDefault();
      if (isDisabled) return null;
      return fetchData({
        data: {
          originalName: fullName,
          updatedName: userName,
          mailNottifications,
        },
      });
    },
    [isDisabled, fetchData, fullName, userName, mailNottifications]
  );

  useEffect(() => {
    if (!isFetched) return;

    dispatch(
      updateUserData({
        fullName: userName,
        settings: {
          ...settings,
          registeredJobMail: mailNottifications,
        },
      })
    );
  }, [isFetched, dispatch, userName, settings, mailNottifications]);

  if (isLoading) return <Loading style={{ height: 200 }} />;

  return (
    <Form className='p-3' autoComplete='off' onSubmit={submitHandeler}>
      {error && <AlertMessage alertMessage='Es ist ein Fehler aufgetreten. Die Info kann nicht aktualisiert werden.' autoDismiss={true} />}
      <StatefulField reqired={true} id='full-name' label='Name' value={userName} updateValue={setUserName} hint={hint} validator={!isNameEmpty && !isDisabled} maxLength='50' />
      {/* <ToggleMailNotifications mailNottifications={mailNottifications} setMailNottifications={setMailNottifications} /> */}
      <Button type='submit' disabled={isDisabled}>
        Info aktualisieren
      </Button>
    </Form>
  );
};

/**
 * Take services from redux store and return it
 * in components props.
 */
const mapStateToProps = ({ userData: { fullName, settings } }) => ({ fullName, settings });

export default connect(mapStateToProps)(ProlifeInfo);
